const MotorControlCenterFormFields = {
    id: "id",
    motorControlCenterName: "motorControlCenterName",
}
export default MotorControlCenterFormFields;